<template>
  <b-row
    align-v="center"
    @mouseover="setContextOnHover(contextHelpRoot+'Current')"
    @mouseleave="setContextOnHover(contextHelpRoot+'Current')"
  >
    <b-col class="m-0">
      <p class="label">
        Y-axis
      </p>
    </b-col>
    <b-col class="m-0">
      <SimpleDropdownConfiguration :controller="InputY" />
    </b-col>
    <b-col class="m-0">
      <SimpleDropdownConfiguration :controller="OutputY" />
    </b-col>
    <b-col class="m-0">
      <CheckBoxConfiguration
        :controller="LogY_axis"
        :switchprop="true"
      />
    </b-col>
  </b-row>
</template>

<script>
import {comboBoxConfCtrller, checkBoxGraphConfCtrller} from '@/assets/classes/configuration.js'
import SimpleDropdownConfiguration from '../elements/SimpleDropdownConfiguration'
import CheckBoxConfiguration from '../elements/CheckBoxConfiguration'
import { ConfigName } from '@/common/sharedDefinitions/commonPlotDefinitions'
import { mapActions } from 'vuex'

const contextHelpRoot='ReportViewer/Units/'
export default {
  name: 'GenericYConfiguration',
  components: { 
    SimpleDropdownConfiguration,
    CheckBoxConfiguration
  },
  data () {
    return {
      InputY: new comboBoxConfCtrller(ConfigName.GenericYAxisInputUnit,
        [
          {text:'G',value:9},
          {text:'M',value:6},
          {text:'k',value:3},
          {text:'1',value:0},
          {text:'m',value:-3},
          {text:'μ',value:-6},
          {text:'n',value:-9},
        ],'Input Magnitude',3,`${contextHelpRoot}InputY`,true),
      OutputY:  new comboBoxConfCtrller(ConfigName.GenericYAxisOutputUnit,
        [
          {text:'G',value:9},
          {text:'M',value:6},
          {text:'k',value:3},
          {text:'1',value:0},
          {text:'m',value:-3},
          {text:'μ',value:-6},
          {text:'n',value:-9},
        ],'Output Magnitude',3,`${contextHelpRoot}OutputY`,true),
        LogY_axis: new checkBoxGraphConfCtrller(`${ConfigName.BaseAxisProperties}.LOGY_BOOL`,'LogY Axis',false,contextHelpRoot+'LogY_axis'),
      elementsConfig:[],
      contextHelpRoot
    }
  },
  mounted(){
    this.elementsConfig=[
      this.InputY,
      this.OutputY,
      this.LogY_axis
    ]
    this.elementsConfig.forEach(conf=>conf.configCategory=this.sectionconfig)
    this.elementsConfig.forEach(conf=>conf.setParent(this))
  },
  methods:mapActions(['setContextOnHover','setConfigReportModifiedReportViewer']),
}
</script>

<style lang="scss" scoped>
.label{
  margin:0px;
  font-size: 0.8rem;
}

.header{
  font-weight: bold;
  font-size: 0.9rem;
  margin-bottom: 0.35rem;
}
::v-deep .label-input-text{
  font-size: 0.8rem;
}
</style>
